var map = {
	"./amazonec2": "866a",
	"./amazonec2.vue": "866a",
	"./azure": "42fc",
	"./azure.vue": "42fc",
	"./digitalocean": "1573",
	"./digitalocean.vue": "1573",
	"./generic": "a3ab",
	"./generic.vue": "a3ab",
	"./linode": "498c",
	"./linode.vue": "498c",
	"./pnap": "08ec",
	"./pnap.vue": "08ec",
	"./vmwarevsphere": "073e",
	"./vmwarevsphere.vue": "073e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "18ae";